export default __webpack_public_path__ + "static/media/bg_404.ad8cae3e.png";